import { render, staticRenderFns } from "./addturntable.vue?vue&type=template&id=78f87a2e&scoped=true"
import script from "./addturntable.vue?vue&type=script&lang=js"
export * from "./addturntable.vue?vue&type=script&lang=js"
import style0 from "./addturntable.vue?vue&type=style&index=0&id=78f87a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f87a2e",
  null
  
)

export default component.exports